"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _CollapsibleTrigger = _interopRequireDefault(require("./CollapsibleTrigger.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var CollapsibleTrigger = function CollapsibleTrigger(_ref) {
  var actions = _ref.actions,
    titleText = _ref.titleText,
    titleValue = _ref.titleValue,
    disabledCollapse = _ref.disabledCollapse,
    onDelete = _ref.onDelete,
    noCollapse = _ref.noCollapse;
  return /*#__PURE__*/_react["default"].createElement(_CollapsibleTrigger["default"], {
    className: "CollapsibleHeader",
    disabledCollapse: disabledCollapse
  }, titleText, titleValue ? ': ' : '', " ", /*#__PURE__*/_react["default"].createElement("b", null, titleValue), !disabledCollapse && !noCollapse && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-android-arrow-dropdown",
    size: 24,
    className: "toggle-icon"
  }), actions && R.map(function (action) {
    return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      key: "".concat(action.icon, "action"),
      icon: action.icon,
      size: 24,
      onClick: action.clickHandler
    });
  }, actions), onDelete && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "collapsible-trigger-delete",
    icon: "ion-android-delete",
    onClick: function onClick(e) {
      e.stopPropagation();
      onDelete();
    },
    size: 16
  }));
};
CollapsibleTrigger.defaultProps = {
  actions: [],
  titleValue: undefined,
  disabledCollapse: false,
  onDelete: null,
  noCollapse: false
};
CollapsibleTrigger.propTypes = {
  /** Elements to be displayed at the right side of the collapsible toggle (eg. Delete button) */
  actions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    clickHandler: _propTypes["default"].func,
    icon: _propTypes["default"].string
  })),
  /** A title to be rendered in left side of the collapsible title bar (eg. `Eligibility rule` ) */
  titleText: _propTypes["default"].string.isRequired,
  /** A title to be rendered in left side of the collapsible title bar;
   * will be highlithed (eg. Car allowance)
   * */
  titleValue: _propTypes["default"].string,
  /** Flag to indicate if the trigger should be disabled; Will not have a toggle icon. */
  disabledCollapse: _propTypes["default"].bool,
  /** Callback to handle deletion of the Collapsible Block */
  onDelete: _propTypes["default"].func,
  /** Flag to hide the collapse button */
  noCollapse: _propTypes["default"].bool
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(CollapsibleTrigger);